import { titleCase } from 'utils'

export const DEFAULT_VIDEO_VOICEOVER_VOICE = 'Kore'
export const DEFAULT_VIDEO_CAPTION_STYLE = 'simple'

export const VIDEO_VOICEOVER_VOICES_FEMALE = [
  { key: 'Achernar', label: 'Achernar — Soft' },
  { key: 'Aoede', label: 'Aoede — Breezy' },
  { key: 'Autonoe', label: 'Autonoe — Bright' },
  { key: 'Callirrhoe', label: 'Callirrhoe — Easy-going' },
  { key: 'Despina', label: 'Despina — Smooth' },
  { key: 'Erinome', label: 'Erinome — Clear' },
  { key: 'Gacrux', label: 'Gacrux — Mature' },
  { key: 'Kore', label: 'Kore — Firm' },
  { key: 'Laomedeia', label: 'Laomedeia — Upbeat' },
  { key: 'Leda', label: 'Leda — Youthful' },
  { key: 'Pulcherrima', label: 'Pulcherrima — Forward' },
  { key: 'Sulafat', label: 'Sulafat — Warm' },
  { key: 'Vindemiatrix', label: 'Vindemiatrix — Gentle' },
  { key: 'Zephyr', label: 'Zephyr — Bright' },
] as const

export const VIDEO_VOICEOVER_VOICES_MALE = [
  { key: 'Achird', label: 'Achird — Friendly' },
  { key: 'Algenib', label: 'Algenib — Gravelly' },
  { key: 'Algieba', label: 'Algieba — Smooth' },
  { key: 'Alnilam', label: 'Alnilam — Firm' },
  { key: 'Charon', label: 'Charon — Informative' },
  { key: 'Enceladus', label: 'Enceladus — Breathy' },
  { key: 'Fenrir', label: 'Fenrir — Excitable' },
  { key: 'Iapetus', label: 'Iapetus — Clear' },
  { key: 'Orus', label: 'Orus — Firm' },
  { key: 'Puck', label: 'Puck — Upbeat' },
  { key: 'Rasalgethi', label: 'Rasalgethi — Informative' },
  { key: 'Sadachbia', label: 'Sadachbia — Lively' },
  { key: 'Sadaltager', label: 'Sadaltager — Knowledgeable' },
  { key: 'Schedar', label: 'Schedar — Even' },
  { key: 'Umbriel', label: 'Umbriel — Easy-going' },
  { key: 'Zubenelgenubi', label: 'Zubenelgenubi — Casual' },
] as const

export const VIDEO_VOICEOVER_VOICES = [...VIDEO_VOICEOVER_VOICES_FEMALE, ...VIDEO_VOICEOVER_VOICES_MALE] as const

// Veed subtitle presets (see backend VideoCaptionStyle)
export const VIDEO_CAPTION_PRESETS = [
  'simple',
  'plain',
  'beans',
  'corpo',
  'boo',
  'shadeplay',
  'casper',
  'lowkey',
  'vinta',
  'diego',
  'ali',
  'kitty',
  'hustle',
  'karl',
  'sprout',
  'flex',
  'mint',
  'rizz',
  'vegas',
] as const

export const VIDEO_CAPTION_STYLE_OPTIONS = VIDEO_CAPTION_PRESETS.map((key) => ({
  key,
  label: titleCase(key),
}))

export type VideoCaptionStyle = (typeof VIDEO_CAPTION_PRESETS)[number]

export type VideoVoiceoverVoice = (typeof VIDEO_VOICEOVER_VOICES)[number]['key']

export const getVideoCaptionStyleLabel = (styleKey: string) => {
  const match = VIDEO_CAPTION_STYLE_OPTIONS.find((option) => option.key === styleKey)
  return match?.label ?? titleCase(styleKey)
}

export const resolveVideoCaptionStyle = (styleKey: string | null | undefined): VideoCaptionStyle => {
  if (styleKey && VIDEO_CAPTION_PRESETS.includes(styleKey as VideoCaptionStyle)) {
    return styleKey as VideoCaptionStyle
  }
  return DEFAULT_VIDEO_CAPTION_STYLE
}

export const resolveVideoVoiceoverVoice = (voiceKey: string | null | undefined): VideoVoiceoverVoice => {
  const match = VIDEO_VOICEOVER_VOICES.find((voice) => voice.key === voiceKey)
  return match?.key ?? DEFAULT_VIDEO_VOICEOVER_VOICE
}
